import { KotlinLoggingConfiguration_getInstance2gskotrxa3wxw as KotlinLoggingConfiguration_getInstance } from './KotlinLoggingConfiguration.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var FormattingAppenderClass;
function FormattingAppender() {
  if (FormattingAppenderClass === VOID) {
    class $ {
      y2e(loggingEvent) {
        // Inline function 'kotlin.let' call
        var it = KotlinLoggingConfiguration_getInstance().a2f_1.c2f().d2f(loggingEvent);
        this.x2e(loggingEvent, it);
      }
    }
    initMetadataForClass($, 'FormattingAppender');
    FormattingAppenderClass = $;
  }
  return FormattingAppenderClass;
}
//region block: exports
export {
  FormattingAppender as FormattingAppender1iqfktuucnzpr,
};
//endregion

//# sourceMappingURL=Appender.mjs.map
